module.exports = __webpack_public_path__ + "static/aboutimg-cace73e4f2833060760f60053d43e165.png";